/**
 * The same password policy as staff accounts (apps/web/src/lib/validation.ts)
 * and the BFF (IsStrongPassword): at least 12 characters with an uppercase
 * letter, a lowercase letter, a number and a special character. The BFF
 * enforces it; the form checks it first and shows the rule (bug #20943).
 * Applies only when a password is set; sign-in accepts existing passwords.
 */
export const PASSWORD_MIN_LENGTH = 12;

export const PASSWORD_RULES_HINT =
  'At least 12 characters, with an uppercase letter, a lowercase letter, a number and a special character.';

export function checkPasswordPolicy(value: string): true | string {
  if (value.length < PASSWORD_MIN_LENGTH) return `Password must be at least ${PASSWORD_MIN_LENGTH} characters`;
  if (!/[A-Z]/.test(value)) return 'Password must contain an uppercase letter';
  if (!/[a-z]/.test(value)) return 'Password must contain a lowercase letter';
  if (!/[0-9]/.test(value)) return 'Password must contain a number';
  if (!/[^A-Za-z0-9]/.test(value)) return 'Password must contain a special character';
  return true;
}

/**
 * react-hook-form rules for a field that sets a new password. Left untyped
 * so it fits each form's own field-value types.
 */
export const newPasswordRules = {
  required: 'Password is required',
  maxLength: { value: 128, message: 'Password must be at most 128 characters' },
  validate: (value: string) => checkPasswordPolicy(String(value ?? '')),
};
